import { render, staticRenderFns } from "./NewSearch.vue?vue&type=template&id=1455b0c2&scoped=true&"
import script from "./NewSearch.vue?vue&type=script&lang=js&"
export * from "./NewSearch.vue?vue&type=script&lang=js&"
import style0 from "./NewSearch.vue?vue&type=style&index=0&id=1455b0c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1455b0c2",
  null
  
)

export default component.exports